<script setup>
defineProps({
  date: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <time :class="{'text-gray-400 italic': date === null}">{{ date === null ? '(not set)' : new Date(date).toLocaleString('nb-NO', {year:'numeric', month:'2-digit', day:'2-digit'}) }}</time>
</template>
